module.exports = __webpack_public_path__ + "img/pants.cd175ca1.svg";